import React from 'react';
import { cn } from '@/lib/utils';

interface BadgeProps {
	children: React.ReactNode;
	className?: string;
	variant?: 'default' | 'secondary' | 'destructive' | 'outline' | 'warning' | 'success' | 'danger' | 'info';
	onClick?: React.MouseEventHandler<HTMLSpanElement>;
}

export const Badge: React.FC<BadgeProps> = ({ 
	children, 
	className,
	variant = 'default',
	onClick 
}) => {
	const baseClasses = "inline-flex items-center rounded-input px-2.5 py-0.5 font-body text-body-xs font-medium transition-colors duration-200";
	
	const variantClasses = {
		default: "bg-primary text-primary-foreground",
		secondary: "bg-secondary text-secondary-foreground",
		destructive: "bg-destructive text-destructive-foreground",
		outline: "text-foreground border border-input",
		warning: "bg-amber-100 text-amber-900 dark:bg-amber-500/20 dark:text-amber-200",
		success: "bg-green-100 text-green-800 dark:bg-green-500/20 dark:text-green-200 border border-green-200 dark:border-green-800",
		danger: "bg-red-100 text-red-800 dark:bg-red-500/20 dark:text-red-200 border border-red-200 dark:border-red-800",
		info: "bg-blue-100 text-blue-800 dark:bg-blue-500/20 dark:text-blue-200 border border-blue-200 dark:border-blue-800",
	};

	return (
		<span onClick={onClick} className={cn(baseClasses, variantClasses[variant], onClick ? 'cursor-pointer' : '', className)}>
			{children}
		</span>
	);
};
